<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header mb-3">
        <span class="col-auto">
          <h2 class="mb-0">Orders Written this month</h2>
        </span>

        <div class="d-flex gap-3 align-items-center">
          <div class="col-auto">
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportQuadReport2()"
              class="fullwdth secondary-btn" />
          </div>

          <span class="cross-border" (click)="onClose()"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <p-table
          #dt
          stripedRows
          [size]="'small'"
          scrollHeight="600px"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          responsiveLayout="scroll"
          [value]="filterQr2List"
          styleClass="table-listing popuptable"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="filterQr2List.length >= 20"
          [autoLayout]="true"
          [resizableColumns]="true"
          (onFilter)="onFilter($event)">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="text-center">Order Date</th>
              <th class="text-center">Order #</th>
              <th class="text-center">Stat</th>
              <th class="text-center">Client Name</th>
              <th
                class="text-center"
                [ngClass]="{ trimmedby30char: descriptionCharacterCond }">
                Job Name
              </th>
              <th class="text-center">Volume</th>
              <th class="text-center">Net Comm</th>
              <th class="text-center">Net GP%</th>
            </tr>
            <tr>
              <th>
                <div class="p-d-flex p-flex-column p-ai-center">
                  <div
                    class="filter-toggle text-center"
                    (click)="showFilterDialog = !showFilterDialog">
                    <i class="pi pi-filter"></i>
                  </div>
                  <p-dialog
                    header="Select Filter Criteria 2"
                    [position]="'left'"
                    [resizable]="false"
                    [draggable]="false"
                    [(visible)]="showFilterDialog"
                    [style]="{
                      width: '300px',
                      height: '335px',
                      'border-radius': '10px',
                      overflow: 'visible',
                    }">
                    <div class="p-fluid p-dir-col p-p-3">
                      <div class="p-field p-mb-2 field-wrap">
                        <label
                          class="text-bold matchMode form-group has-float-label mb-1"
                          for="selectedMatchMode"
                          >Match Mode</label
                        >
                        <p-select
                          [options]="matchModeOptions"
                          [(ngModel)]="selectedMatchMode"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Select Match Mode"
                          [required]="true"></p-select>
                      </div>
                      <div class="p-field p-mb-2 mt-3">
                        <label
                          class="text-bold form-label form-group has-float-label"
                          for="startDate"
                          >{{
                            selectedMatchMode !== "between"
                              ? "Date"
                              : "Start Date"
                          }}
                        </label>
                        <p-date-picker
                          [(ngModel)]="startDate"
                          [showButtonBar]="true"
                          dateFormat="mm-dd-yy"></p-date-picker>
                      </div>
                      <div
                        class="p-field p-mb-2 mt-3"
                        *ngIf="selectedMatchMode === 'between'">
                        <label
                          class="text-bold form-label form-group has-float-label"
                          for="endDate"
                          >End Date</label
                        >
                        <p-date-picker
                          [(ngModel)]="endDate"
                          [showButtonBar]="true"
                          dateFormat="mm-dd-yy"></p-date-picker>
                      </div>

                      <div
                        class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
                        <button
                          class="btn btn-secondary me-3"
                          type="button"
                          (click)="clearFilter()">
                          Clear
                        </button>
                        <button
                          class="btn btn-primary"
                          [disabled]="startDate === ''"
                          type="submit"
                          (click)="applyFilter()">
                          Apply
                        </button>
                      </div>
                    </div>
                  </p-dialog>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrderId"
                    id="salesOrderId"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderId',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="stat"
                    id="stat"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'stat', 'startsWith')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientName"
                    id="clientName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientName',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="jobName"
                    id="jobName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'jobName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="volume"
                    id="volume"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'volume',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="netComm"
                    id="netComm"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'netComm',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="netGPPercentage"
                    id="netGPPercentage"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'netGPPercentage',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-qr2List let-rowIndex="rowIndex">
            <tr>
              <td>{{ qr2List.orderDate | date: "MM-dd-yyyy" }}</td>
              <td>
                <a
                  class="link"
                  (click)="redirectToSummary(qr2List.salesOrderId)"
                  >{{ qr2List.salesOrderId }}</a
                >
              </td>
              <td>{{ qr2List.stat }}</td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClientSummary(qr2List.customerAccountNumber)
                  "
                  >{{ qr2List.clientName }}</a
                >
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby30char':
                    descriptionCharacterCond,
                }">
                {{ descriptionCharacterCount(qr2List.jobName) }}
                {{ qr2List.jobName }}
              </td>
              <td class="align-right">
                {{ qr2List.volume | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ qr2List.netComm | number: "1.2-2" }}
              </td>
              <td class="align-right">
                <span
                  *ngIf="
                    qr2List.netGPPercentage !== 'NaN' &&
                    getInfinity(qr2List.netGPPercentage)
                  ">
                  {{ qr2List.netGPPercentage | number: "1.2-2" }}
                </span>
                <span
                  *ngIf="
                    qr2List.netGPPercentage === 'NaN' ||
                    !getInfinity(qr2List.netGPPercentage)
                  ">
                  {{ 0 | number: "1.2-2" }}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>

              <!-- As per the ticket 12162 totals will show on filters -->
              <!-- <td class="align-right">{{ qR2Reports.totalVolume | number: '1.2-2' }}</td>
        <td class="align-right">{{ qR2Reports.totalNetComm | number: '1.2-2' }}</td>
        <td class="align-right">{{ qR2Reports.totalNetGpPercentage | number: '1.2-2' }}</td> -->
              <td class="align-right">
                {{ qR2Reports.totalVolume | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ qR2Reports.totalNetComm | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ qR2Reports.totalNetGpPercentage | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
